import React from 'react';
import './chart-tooltip.scss';
import 'components/percentile-tag/percentile-tag.scss';
import { assignPercentileRange } from 'pages/search/results/results-utils';
import { ChartTooltipProps } from './chart-tooltip.props';

export const ChartTooltip: React.FC<ChartTooltipProps> = (props) => {
  const displayPercentile = assignPercentileRange(props.percentile);

  return (
    <>
      <div className="sg-chart-tooltip">
        {
          props.nonoptimal
            ? (
              <div className={`sg-percentile-tag highlight--${displayPercentile}`}>{props.percentile <= 50 ? 'TOP' : 'BOTTOM'} {props.percentile > 50 ? `${100 - props.percentile}` : props.percentile}%</div>

            ) : (
              <div className="sg-percentile-tag highlight--0">{props.percentile}%</div>
            )
        }
      </div>
    </>
  );
};
